module.exports = __webpack_public_path__ + "static/media/hp-aftermarket.e9329d41.svg";